/**
 * @desc 获取报价方案
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.LogisticsQuotationTobResponseDto>;
export function request(
  params: API.tms.logisticsQuotationTob.getDetail.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsQuotationTob/getDetail`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
